module.exports = __webpack_public_path__ + "media/images/pikkachan_smile-2ea4bbb2cf3c5e3dff11418e28b7a044.png";